var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatabricks = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3621",
  d: "M18 1.26 1.8 10.41v15.72L18 34.74l16.2-8.61V10.41zm13.32 22.32L18 31.14 4.68 23.58v-4.14L18 27l13.32-7.56zM18 23.4 4.68 15.84V11.7L18 19.26l13.32-7.56v4.14z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatabricks);
export default ForwardRef;